import React from 'react';
import PropTypes from 'prop-types';
import './articleTiles.css';

const ArticleTiles = props => {
  return (
    <div>
      <div className="article-tiles">
        <div className="main">
          {props.articles[0] ? props.articles[0] : null}
        </div>
        <div className="aside">
          <div className="aside-1">
            {props.articles[1] ? props.articles[1] : null}
          </div>
          <div className="aside-2">
            {props.articles[2] ? props.articles[2] : null}
          </div>
        </div>
      </div>
      <div className="article-tiles bottomWraper">
        <div className="bottom bottomSide-1">
          {props.articles[3] ? props.articles[3] : null}
        </div>
        <div className="bottom bottomSide-2">
          {props.articles[4] ? props.articles[4] : null}
        </div>
        <div className="bottom bottomSide-3">
          {props.articles[5] ? props.articles[5] : null}
        </div>
      </div>
    </div>
  );
};

ArticleTiles.propTypes = {
  articles: PropTypes.array.isRequired,
};

export default ArticleTiles;



// WEBPACK FOOTER //
// ./src/app/component/articleTiles/index.js